import { render, staticRenderFns } from "./RecapPanneau.vue?vue&type=template&id=bd535e86"
import script from "./RecapPanneau.vue?vue&type=script&lang=js"
export * from "./RecapPanneau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports